import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { add as addToCart } from '../Actions/Cart.action';
import { translate } from '../Services/translation';

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
    }

    render() {
        const { showLabel } = this.props;
        const { isInStock } = this.props;
        const { href } = this.props;

        return (
            <span ref={this.buttonRef}>
                <BuyButton {...this.props} 
                    onClick={(articleNumber, quantityFieldId) => this.props.addToCart(this.buttonRef.current, articleNumber, quantityFieldId, href, showLabel, isInStock)} />
            </span>
        );
    }
}

const mapStateToProps = state => {
    return { }
}

const mapDispatchToProps = dispatch => {
    return {
        addToCart: (buttonDomNode, articleNumber, quantityFieldId, showLabel) => {
            const nodeIdToShowNotification = buttonDomNode.id = Date.now();
            const quantityElement = quantityFieldId ? document.getElementById(quantityFieldId) : null;
            dispatch(addToCart({
                articleNumber,
                quantity: quantityElement ? quantityElement.value : 1,
                nodeIdToShowNotification,
                notificationMessage: translate('tooltip.addedtocart'),
                hash: Date.now(),
                showLabel, 
            }));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyButtonContainer);
